import Svg, {Path} from 'react-native-svg'

// TODO check light/dark mode, size on different screens
export const OutdatedIcon = () => {
  // useCommonSvg
  const fill = 'white' //'#1f1f1f'
  return (
    <Svg height="40px" width="40px" viewBox="0 0 10.583332 10.583332">
      <Path
        strokeWidth={'0.0125677'}
        fill={fill}
        d="M 5.64618,2.59291 V 5.30774 L 3.73551,7.21743 3.03249,6.51443 4.64076,4.90517 V 2.59291 Z"
      />
      <Path
        strokeWidth={'0.0125677'}
        fill={fill}
        d="M 5.00062,0.58208 C 4.37225,0.58208 3.78405,0.70159 3.23525,0.94046 2.68648,1.17923 2.20811,1.50122 1.80176,1.90758 1.39539,2.31395 1.07342,2.79229 0.83462,3.34109 0.59583,3.88988 0.47625,4.47807 0.47625,5.10646 0.47625,5.73484 0.59576,6.32304 0.83462,6.87182 1.07342,7.42062 1.39539,7.89898 1.80176,8.30533 2.20811,8.71169 2.68648,9.03368 3.23525,9.27245 3.78405,9.51124 4.37225,9.63083 5.00062,9.63083 5.62901,9.63083 6.21721,9.51132 6.76601,9.27245 7.31478,9.03368 7.79315,8.71169 8.1995,8.30533 8.60585,7.89898 8.92785,7.42062 9.16662,6.87182 9.40541,6.32304 9.525,5.73484 9.525,5.10646 9.525,4.47807 9.40549,3.88988 9.16662,3.34109 8.92785,2.79229 8.60585,2.31395 8.1995,1.90758 7.79315,1.50122 7.31478,1.17923 6.76601,0.94046 6.21721,0.70167 5.62901,0.58208 5.00062,0.58208 Z M 5.00062,1.5875 C 5.98091,1.5875 6.81267,1.92872 7.49551,2.61157 8.17835,3.29442 8.51959,4.12619 8.51959,5.10646 8.51959,6.08674 8.17835,6.91848 7.49551,7.60134 6.81267,8.28417 5.98091,8.62541 5.00062,8.62541 4.02033,8.62541 3.18859,8.28417 2.50575,7.60134 1.82291,6.91848 1.48167,6.08674 1.48167,5.10646 1.48167,4.12619 1.82291,3.29442 2.50575,2.61157 3.18859,1.92872 4.02033,1.5875 5.00062,1.5875 Z"
      />
      <Path
        strokeWidth={'0.0125677'}
        fill={fill}
        d="M 7.47764,8.82563 C 7.40606,8.82563 7.34632,8.85105 7.29745,8.89844 7.24907,8.94682 7.22463,9.00656 7.22463,9.07864 7.22463,9.15022 7.25006,9.20996 7.29745,9.25834 7.34583,9.30672 7.40556,9.33115 7.47764,9.33115 7.54923,9.33115 7.61019,9.30573 7.65858,9.25834 7.70696,9.20996 7.73016,9.15022 7.73016,9.07864 7.73016,9.00705 7.70473,8.94732 7.65858,8.89844 7.61019,8.85006 7.54873,8.82563 7.47764,8.82563 Z"
      />
      <Path
        strokeWidth={'2.38311'}
        d="M 7.47764,8.82563 C 7.40606,8.82563 7.34632,8.85105 7.29745,8.89844 7.24907,8.94682 7.22463,9.00656 7.22463,9.07864 7.22463,9.15022 7.25006,9.20996 7.29745,9.25834 7.34583,9.30672 7.40556,9.33115 7.47764,9.33115 7.54923,9.33115 7.61019,9.30573 7.65858,9.25834 7.70696,9.20996 7.73016,9.15022 7.73016,9.07864 7.73016,9.00705 7.70473,8.94732 7.65858,8.89844 7.61019,8.85006 7.54873,8.82563 7.47764,8.82563 Z"
      />
      <Path
        strokeWidth={'2.38311'}
        d="M 7.2252,7.31085 V 8.57316 H 7.73006 V 7.31085 Z"
      />
      <Path
        fill={'#ffffff'}
        strokeWidth={'2.38311'}
        d="M 7.47764,6.301 5.57246,9.58298 H 9.38401 Z M 7.22508,7.31085 H 7.72994 V 8.57316 H 7.22508 Z M 7.47764,8.82563 C 7.54923,8.82563 7.61019,8.85105 7.65858,8.89844 7.70696,8.94682 7.73016,9.00656 7.73016,9.07864 7.73016,9.15022 7.70473,9.20996 7.65858,9.25834 7.61019,9.30672 7.54873,9.33115 7.47764,9.33115 7.40606,9.33115 7.34632,9.30573 7.29745,9.25834 7.24907,9.20996 7.22463,9.15022 7.22463,9.07864 7.22463,9.00705 7.25006,8.94732 7.29745,8.89844 7.34583,8.85006 7.40556,8.82563 7.47764,8.82563 Z"
      />
      <Path
        strokeWidth={'2.38311'}
        d="M 7.47764,5.29118 4.70058,10.08789 H 10.25592 Z M 7.47764,6.301 9.38401,9.58298 H 5.57246 Z"
      />
      <Path
        stroke={'#ffffff'}
        strokeWidth={'0.2'}
        d="M 7.47815,5.23916 A 0.0536946,0.0536946 0 0 0 7.43128,5.26455 L 4.65394,10.06143 A 0.0536946,0.0536946 0 0 0 4.70081,10.1415 H 10.2555 A 0.0536946,0.0536946 0 0 0 10.30237,10.06143 L 7.52503,5.26455 A 0.0536946,0.0536946 0 0 0 7.47815,5.23916 Z M 7.47815,6.40908 9.29065,9.53018 H 5.66565 Z"
      />
    </Svg>
  )
}
